/** Display-only AZN → play currency conversion (matches backend ROUND_HALF_UP). */

export function aznMinorToPlayMinor(aznMinor: number, rateAznPerUnit: string | number | undefined): number {
  const azn = Number(aznMinor) || 0;
  const rate = Number(rateAznPerUnit);
  if (!Number.isFinite(rate) || rate <= 0 || rate === 1) return azn;
  // (azn/100) / rate → play major, half-up to 2 dp, then minor
  const playMajor = azn / 100 / rate;
  return Math.round(playMajor * 100 + Number.EPSILON);
}

/** Convert AZN min limit up so displayed min never undercuts the AZN floor. */
export function aznMinorToPlayMinorCeil(aznMinor: number, rateAznPerUnit: string | number | undefined): number {
  const azn = Number(aznMinor) || 0;
  const rate = Number(rateAznPerUnit);
  if (!Number.isFinite(rate) || rate <= 0 || rate === 1) return azn;
  const playMajor = azn / 100 / rate;
  return Math.ceil(playMajor * 100 - Number.EPSILON);
}

/** Convert AZN max limit down so displayed max never exceeds the AZN ceiling. */
export function aznMinorToPlayMinorFloor(aznMinor: number, rateAznPerUnit: string | number | undefined): number {
  const azn = Number(aznMinor) || 0;
  const rate = Number(rateAznPerUnit);
  if (!Number.isFinite(rate) || rate <= 0 || rate === 1) return azn;
  const playMajor = azn / 100 / rate;
  return Math.max(0, Math.floor(playMajor * 100 + Number.EPSILON));
}

/** Convert display-currency major amount → AZN minor for ledger APIs. */
export function playMajorToAznMinor(playMajor: number, rateAznPerUnit: string | number | undefined): number {
  const major = Number(playMajor) || 0;
  const rate = Number(rateAznPerUnit);
  if (!Number.isFinite(major)) return 0;
  if (!Number.isFinite(rate) || rate <= 0 || rate === 1) return Math.round(major * 100);
  return Math.round(major * rate * 100 + Number.EPSILON);
}

export function wageringPercent(completedMinor: number, targetMinor: number): number {
  const target = Number(targetMinor) || 0;
  if (target <= 0) return 0;
  const pct = (Math.max(0, Number(completedMinor) || 0) / target) * 100;
  return Math.min(100, Math.round(pct));
}
